import React from 'react';

import Link from '@dashboard/components/mui-atoms/Link';
import { useContactsGroupQuery } from '@dashboard/generated/wp/platform';
import useCurrentPlatformId from '@dashboard/hooks/route/useCurrentPlatformId';
import { Skeleton } from '@mui/material';

type Props = {
  contactsGroupId?: string | null;
};
export default function ContactsGroupLink({ contactsGroupId }: Props) {
  const platformId = useCurrentPlatformId();
  const { data } = useContactsGroupQuery({
    variables: { id: contactsGroupId ?? '' },
    skip: !contactsGroupId,
  });
  if (!contactsGroupId) {
    return <>--</>;
  }
  const contactsGroupName = data?.ContactsGroup.name;
  if (!contactsGroupName) {
    return <Skeleton width={250} />;
  }
  return (
    <Link href={`/o/${platformId}/groups/${contactsGroupId}`} underline="hover">
      {contactsGroupName}
    </Link>
  );
}
